<template>
  <div class="loyalty-tiers-container">
    <h4 class="heading">Tiers Explained</h4>
    <div class="loyalty-tiers">
      <div class="loyalty-tier">
        <div class="header header--standard">
          <h3 class="header__heading">White</h3>
        </div>
        <div class="loyalty-tier__info">
          <div class="rewards">
            <div class="rewards__type">Annual Spend</div>
            <div class="rewards__info">£0</div>
            <div class="rewards__type">Style points to credits</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Vote on New Styles</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Early Collection Access</div>
            <div class="rewards__info">
              <span class="icon icon--no"></span>
            </div>
            <div class="rewards__type">Free Shipping and returns</div>
            <div class="rewards__info">
              <span class="icon icon--no"></span>
            </div>
          </div>
          <div class="loyalty-tier__buttons">
            <Button full-width theme="outline" @click="setSlideLogin(true)"
              >Sign in to your account</Button
            >
            <Button full-width @click="setSlideSignUp(true)"
              >Sign up to get 400 style points</Button
            >
          </div>
        </div>
      </div>
      <div class="loyalty-tier">
        <div class="header header--premium">
          <h3 class="header__heading">Grey</h3>
        </div>
        <div class="loyalty-tier__info">
          <div class="rewards">
            <div class="rewards__type">Annual Spend</div>
            <div class="rewards__info">£190</div>
            <div class="rewards__type">Style points to credits</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Vote on New Styles</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Early Collection Access</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Free Shipping and returns</div>
            <div class="rewards__info">
              <span class="icon icon--no"></span>
            </div>
          </div>
          <div class="loyalty-tier__buttons">
            <Button full-width theme="outline" @click="setSlideLogin(true)"
              >Sign in to your account</Button
            >
            <Button full-width @click="setSlideSignUp(true)"
              >Sign up to get 400 style points</Button
            >
          </div>
        </div>
      </div>
      <div class="loyalty-tier">
        <div class="header header--luxury">
          <h3 class="header__heading">Black</h3>
        </div>
        <div class="loyalty-tier__info">
          <div class="rewards">
            <div class="rewards__type">Annual Spend</div>
            <div class="rewards__info">£380</div>
            <div class="rewards__type">Style points to credits</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Vote on New Styles</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Early Collection Access</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
            <div class="rewards__type">Free Shipping and returns</div>
            <div class="rewards__info">
              <span class="icon icon--yes"></span>
            </div>
          </div>
          <div class="loyalty-tier__buttons">
            <Button full-width theme="outline" @click="setSlideLogin(true)"
              >Sign in to your account</Button
            >
            <Button full-width @click="setSlideSignUp(true)"
              >Sign up to get 400 style points</Button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
export default {
  name: "LoyaltyTiers",
  components: {
    Button,
  },
  methods: {
    ...mapActions("app", ["setSlideSignUp", "setSlideLogin"]),
  },
};
</script>

<style lang="scss" scoped>
.loyalty-tiers-container {
  background-color: $color-light;
  padding: 60px 0;

  @include respond-above(md) {
    padding: 80px 0;
  }
}
.loyalty-tiers {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;

  @include respond-above(md) {
    display: grid;
    column-gap: 2px;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 auto;
    max-width: 1280px;
  }
}

.heading {
  color: $color-dark;
  font-family: $heading-font-family;
  font-size: 16px;
  font-weight: 400;
  padding: 0 0 0 20px;
  margin: 0 auto 20px;
  max-width: 1280px;
  text-transform: uppercase;
  @include respond-above(md) {
    font-size: 30px;
  }
}

.loyalty-tier {
  background-color: $color-white;
  margin: 0 2px 0 0;
  &:last-child {
    margin: 0;
  }
  &__info {
    padding: 30px 20px;
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px 20px;
  min-width: 280px;

  @include respond-above(md) {
    padding: 60px 20px;
    width: auto;
  }

  &--standard {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-tier-white.webp?v=1664885471");
    background-position: center center;
    background-size: cover;
  }

  &--premium {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-tier-grey.webp?v=1664885472");
    background-position: center center;
    background-size: cover;
  }

  &--luxury {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-tier-black.webp?v=1664885471");
    background-position: center center;
    background-size: cover;
  }

  &__heading {
    color: $color-white;
    font-size: 22px;
    font-weight: 400;
    margin: 0 0 5px 0;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 40px;
    }
  }
  .text {
    color: $color-white;
    font-family: $heading-font-family;
    font-size: 12px;
    font-weight: 300;
    text-align: center;

    @include respond-above(md) {
      font-size: 14px;
    }
  }
}

.rewards {
  display: grid;
  grid-template-columns: 3fr 1fr;
  margin: 0 0 20px 0;
  row-gap: 20px;

  &__type {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 10px;
    }
  }

  &__info {
    align-items: center;
    display: flex;
    font-size: 11px;
    font-weight: normal;
    justify-content: center;

    @include respond-above(md) {
      font-size: 12px;
    }
  }
}

.icon {
  display: block;
}

.icon--yes {
  background-image: url("@/assets/images/yes.svg");
  background-size: contain;
  height: 16px;
  width: 16px;
}

.icon--no {
  background-image: url("@/assets/images/no.svg");
  background-size: contain;
  opacity: 0.25;
  height: 16px;
  width: 16px;
}
</style>
